<template>
    <modal title="" width="35" :showModal="showModal" @close-modal="closeModal">

    <div>
        <h1>Delete</h1>
        <p>Confirm you want to delete this quote.</p>
        <div class="butt-wrap flex gap-2">
            <button @click="closeModal()" class="px-2 py-2">No, Go Back</button>
            <button @click="deleteQuoteAndDrafts()" class="px-2 py-2 ">Yes, Delete</button>
        </div>
    </div>
  
    </modal>
  </template>
  
  <script>



  export default {

    props: {
      showModal: {
        type: Boolean,
        required: true,
      },
       shippingId: {
         type: String
       },
       quoteId: {
         type: String
       }
    },
    data() {
      return {  
        transId : null,
      };
    },
    methods: {
        async deleteQuoteAndDrafts() {
          if (this.shippingId) {
            this.transId = this.shippingId
          }
          if (this.quoteId) {
            this.transId = this.quoteId
            this.$router.push( {name : "QuoteAndDraft"})
          }   
      try {
        const response = await this.$_deleteQuoteAndDraftCustomer(this.transId);
        if (response.status === 200) {
          this.closeModal()
          window.location.reload();
          this.generateToast("Quote successfully deleted!", "success");
        }
      } catch (error) {

        this.handleError(error);
      }
    },

      closeModal() {
        this.$emit("close-modal");
      },
 
    },
  };
  </script>
  
  <style scoped lang="scss">

  h1{
    
    color : #10233E;
    font-size : 18px;
    font-weight : 700;
    margin-bottom : 5%;
  }

  p{
    color : #383F51;
    font-size : 16px;
    font-weight : 400;
    margin-bottom : 5%;
  }
  .butt-wrap{
    text-align: end;
    justify-content: end;
  }
  .butt-wrap>button{
    color : #10233E;
    font-size : 16px;
    font-weight : 600;
    
  }
  .butt-wrap :nth-child(2){
    box-shadow: #DD900940;
    background:#FCC210;
    border-radius : 4px;
  }
  
  </style> 
  